/**
 * Cart page — mobile sticky checkout bar
 */
(function () {
  if (!document.body.classList.contains('template-cart')) return;

  const cartPage = document.querySelector('.nihooya-cart-page');
  const checkoutBtn = document.getElementById('checkout');
  const subtotalEl = document.querySelector('.nihooya-cart-page__summary .totals__subtotal-value');
  const mobileBar = document.querySelector('[data-nihooya-cart-mobile-bar]');
  const mobileQuery = window.matchMedia('(max-width: 989px)');

  if (!cartPage || cartPage.classList.contains('is-empty') || !checkoutBtn || !mobileBar) return;

  const barPrice = mobileBar.querySelector('[data-nihooya-cart-mobile-price]');
  const barBtn = mobileBar.querySelector('[data-nihooya-cart-mobile-checkout]');

  function isMobileLayout() {
    return mobileQuery.matches;
  }

  function syncBar() {
    if (barPrice && subtotalEl) {
      barPrice.textContent = subtotalEl.textContent.trim();
    }
    if (barBtn) {
      barBtn.disabled = checkoutBtn.disabled;
      barBtn.textContent = checkoutBtn.textContent.trim();
    }
  }

  function setBarVisible(visible) {
    if (!isMobileLayout()) {
      mobileBar.classList.remove('is-visible');
      mobileBar.setAttribute('aria-hidden', 'true');
      mobileBar.setAttribute('inert', '');
      return;
    }

    mobileBar.classList.toggle('is-visible', visible);
    mobileBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    if (visible) {
      mobileBar.removeAttribute('inert');
    } else {
      mobileBar.setAttribute('inert', '');
    }
  }

  function initObserver() {
    const summary = document.querySelector('.nihooya-cart-page__summary');
    if (!summary || !('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setBarVisible(!entry.isIntersecting);
      },
      { root: null, threshold: 0, rootMargin: '0px' }
    );

    observer.observe(summary);
    mobileQuery.addEventListener('change', () => {
      if (!isMobileLayout()) setBarVisible(false);
    });
  }

  barBtn?.addEventListener('click', () => {
    if (checkoutBtn.disabled) return;
    checkoutBtn.click();
  });

  const observer = new MutationObserver(syncBar);
  if (subtotalEl) observer.observe(subtotalEl, { childList: true, characterData: true, subtree: true });
  observer.observe(checkoutBtn, { attributes: true, childList: true, subtree: true });

  setBarVisible(false);
  syncBar();
  initObserver();
})();